import { AxiosResponse } from 'axios';
import AxiosInstanceBFF from './AxiosInstanceBFF';

export const getBusinessHoursSchedules = async (): Promise<AxiosResponse<[]>> =>
  AxiosInstanceBFF.get('v1/business-hours/schedules');
